import React from 'react'
import { Animated, StyleProp, ViewStyle } from 'react-native'
import { isWeb } from 'APP/Helpers/checkPlatform'

// Components
import ImageMapPicker from 'APP/Components/ImageMapPicker'

// Styles
import { Styles } from './style'

type ImageMapPickerProps = React.ComponentProps<typeof ImageMapPicker>

interface IntakeImageMapProps extends Omit<ImageMapPickerProps, 'ready' | 'includeListView'> {
  style?: StyleProp<ViewStyle>
}

const IntakeImageMap: React.FC<IntakeImageMapProps> = ({ style, ...rest }) => {
  return (
    <Animated.View testID="VIEW_INTAKE_IMAGE_MAP" style={[Styles.container, style]}>
      <ImageMapPicker includeListView={isWeb()} {...rest} ready={!isWeb()} />
    </Animated.View>
  )
}

export default IntakeImageMap
